import React from 'react';

import AddAccountFormContainer from '../../AddAccountFormContainer';
import { AddAccountFormViewModel } from 'src/types/view-models/addAccount/addAccount.view.model';
import { InvestmentHoldingSubtype, InvestmentHoldingType } from 'src/types/investment-holding.model';

// TODO needs to be "Form" first because functions must start with a letter
export default function Form401kAnd403b({ manualAccount, onSubmit, handleBack }: AddAccountFormViewModel): JSX.Element {
    return (
        <AddAccountFormContainer
            manualAccount={manualAccount}
            onSubmit={(values) => {
                void onSubmit(
                    values,
                    manualAccount,
                    false,
                    InvestmentHoldingType.Retire,
                    InvestmentHoldingSubtype['401kAnd403b']
                );
            }}
            handleBack={handleBack}
        />
    );
}
